export class UsertType {
  id: number = -1;
  name: string = '';
  description: string = '';
  benefits?: string[];
}
